import { cn } from '@lair-finance/util'
import { CSSProperties } from 'react'
import { NOTIFICATION } from '@/domains/header/config/notification.ts'

export const NotificationBar = ({ className, style }: { className?: string; style?: CSSProperties }) => {
  if (!NOTIFICATION) return null

  return (
    <div
      className={cn(`flex-center typo-headline-2 bg-repeat bg-center text-center h-[40px]`, className)}
      style={{ color: NOTIFICATION.color, backgroundImage: `url(${NOTIFICATION.imageUrl})`, ...style }}
    >
      {NOTIFICATION.text}
    </div>
  )
}
